const schema = [
        ['advanceHours'],
        ['mailText'],
        ['projectDate'],
        ['roles'],
        ['sentAt'],
];

export default schema;
